import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { SuperAdminAuthProvider } from '@/superadmin/SuperAdminAuth';
import SuperAdminLoginPage from '@/superadmin/SuperAdminLoginPage';
import SuperAdminLayout from '@/superadmin/SuperAdminLayout';
import SuperDashboardPage from '@/superadmin/SuperDashboardPage';
import SuperCompaniesPage from '@/superadmin/SuperCompaniesPage';
import SuperStaffRolesPage from '@/superadmin/SuperStaffRolesPage';
import SuperPlatformEmailPage from '@/superadmin/SuperPlatformEmailPage';
import SuperAuditLogPage from '@/superadmin/SuperAuditLogPage';
import SuperBroadcastPage from '@/superadmin/SuperBroadcastPage';
import {
  SuperBillingPage, SuperFeatureFlagsPage, SuperSystemHealthPage
} from '@/superadmin/SuperStubPages';
import SuperApiQuotasPage from '@/superadmin/SuperApiQuotasPage';
import SuperOnboardingPage from '@/superadmin/SuperOnboardingPage';
import SuperBillingDetailPage from '@/superadmin/SuperBillingDetailPage';
import SuperPlansPage from '@/superadmin/SuperPlansPage';
import SuperCompanyDetailPage from '@/superadmin/SuperCompanyDetailPage';
import SuperSalesChannelsPage from '@/superadmin/SuperSalesChannelsPage';
import SuperDataCleanupPage from '@/superadmin/SuperDataCleanupPage';
import SuperDomainAuthPage from '@/superadmin/SuperDomainAuthPage';
import StripeSettingsPage from '@/pages/StripeSettingsPage';

/**
 * Single mount point for the entire Super-Admin portal.
 * One provider instance covers both /login and the authenticated layout,
 * so the logged-in user state (and token/permissions) isn't lost when
 * navigating between them.
 */
const SuperAdminRoutes = () => (
  <SuperAdminAuthProvider>
    <Routes>
      <Route path="login" element={<SuperAdminLoginPage />} />
      <Route path="/" element={<SuperAdminLayout />}>
        <Route index element={<SuperDashboardPage />} />
        <Route path="companies" element={<SuperCompaniesPage />} />
        <Route path="companies/:companyId" element={<SuperCompanyDetailPage />} />
        <Route path="plans" element={<SuperPlansPage />} />
        <Route path="billing" element={<SuperBillingPage />} />
        <Route path="billing/:companyId" element={<SuperBillingDetailPage />} />
        <Route path="stripe-settings" element={<StripeSettingsPage />} />
        <Route path="staff" element={<SuperStaffRolesPage defaultTab="staff" />} />
        <Route path="roles" element={<SuperStaffRolesPage defaultTab="roles" />} />
        <Route path="platform-email" element={<SuperPlatformEmailPage />} />
        <Route path="domain-auth" element={<SuperDomainAuthPage />} />
        <Route path="broadcast" element={<SuperBroadcastPage />} />
        <Route path="feature-flags" element={<SuperFeatureFlagsPage />} />
        <Route path="api-quotas" element={<SuperApiQuotasPage />} />
        <Route path="onboarding" element={<SuperOnboardingPage />} />
        <Route path="audit-log" element={<SuperAuditLogPage />} />
        <Route path="system-health" element={<SuperSystemHealthPage />} />
        <Route path="sales-channels" element={<SuperSalesChannelsPage />} />
        <Route path="data-cleanup" element={<SuperDataCleanupPage />} />
      </Route>
    </Routes>
  </SuperAdminAuthProvider>
);

export default SuperAdminRoutes;
